import { useState, useEffect } from 'react';
import { getEducations } from 'api';
import type { EducationType } from 'interfaces';

export const useFetchEducationTypes = () => {
  const [educationTypes, setEducationTypes] = useState<EducationType[]>([]);

  useEffect(() => {
    let stillMounted = true;

    const getData = async () => {
      try {
        const response = await getEducations();
        setEducationTypes(response.data);
      } catch (error) {
        setEducationTypes([]);
        throw error;
      }
    };

    if (stillMounted) {
      getData();
    }

    return () => {
      stillMounted = false;
    };
  }, []);

  return { educationTypes };
};
